import { useStore } from "vuex";
import axios from "@/plugins/axios";
import { useRouter } from "vue-router";
import { ref } from "vue";

export function useDoctor() {
  const doctorData = ref({
    Type: "",
    Clinicname: "",
    Clinicdivision: "",
    Gender: "",
    Title: "",
    Firstname: "",
    Surname: "",
    Specialty: "",
    Phone: "",
    Email: "",
    Street: "",
    Housenumber: "",
    Zip: "",
    City: "",
    CityLat: "",
    CityLng: "",
    IsCase: "0",

    From: "",
    Id: "",
  });

  const store = useStore();
  const addDoctor = async (ztkLocation) => {
    store.commit("setShowLoading", true);
    const ztkLocationData = {};
    if (ztkLocation) {
      ztkLocationData.Type = "clinic";
      ztkLocationData.Clinicname =
        "Zahnärztliche Tagesklinik " + ztkLocation.name;
      ztkLocationData.Phone = ztkLocation.tel;
      ztkLocationData.Street = ztkLocation.address.street;
      ztkLocationData.Housenumber = ztkLocation.address.housenumber;
      ztkLocationData.Zip = ztkLocation.address.zip;
      ztkLocationData.City = ztkLocation.address.city;
      ztkLocationData.CityLat = ztkLocation.position.lat;
      ztkLocationData.CityLng = ztkLocation.position.lng;
    }
    const data = {
      ...doctorData.value,
      ...ztkLocationData,
    };
    await axios.post("?Mode=General&Function=SaveDoctor", data);
  };

  const getAppointmentStatus = (appointment) => {
    let result = "";
    const foundConversation = store.state.conversations.find(
      (obj) => obj.caseId === appointment.Id
    );
    if (foundConversation) {
      const foundLastAppointmentMessage = foundConversation.messages.findLast(
        (obj) => obj.Meta?.appointmentId === appointment.AppointmentId
      );
      if (foundLastAppointmentMessage) {
        result = foundLastAppointmentMessage.Type;
      }
    }
    return result;
  };

  const findDoctorIndex = (doctorsSrc, doctor) => {
    if (doctorsSrc.IsUserAppointmentOnly || doctor.IsUserAppointmentOnly) {
      return -1;
    } else {
      return doctorsSrc.findIndex(
        (obj) =>
          obj.Surname?.trim() === doctor.Surname?.trim() &&
          obj.Firstname?.trim() === doctor.Firstname?.trim() &&
          obj.Specialty?.trim() === doctor.Specialty?.trim() &&
          obj.Zip?.trim() === doctor.Zip?.trim() &&
          obj.Street?.trim() === doctor.Street?.trim() &&
          obj.Housenumber?.trim() === doctor.Housenumber?.trim()
      );
    }
  };
  const getDoctors = async () => {
    store.commit("setShowLoading", true);
    const doctorsResponse = await axios.post(
      "?Mode=General&Function=GetDoctors"
    );
    if (
      doctorsResponse.data.Status === "Success" &&
      doctorsResponse.data.Result
    ) {
      const appointments = [];
      let doctors = [];
      const proposed = [];

      if (doctorsResponse.data.Result.Appointments) {
        const normalizedAppointments = [];
        for (const [
          appointmentIndex,
          appointment,
        ] of doctorsResponse.data.Result.Appointments.entries()) {
          appointment.Index = appointmentIndex;
          appointment.From = "Appointments";
          // appointment.dates = new Set([]);
          // for (let i = 1; i <= 5; i++) {
          //   if (appointment["Date" + i]) {
          //     appointment.dates.add(appointment["Date" + i]);
          //   }
          //   delete appointment["Date" + i];
          // }
          const equalAppointmentIndex = findDoctorIndex(
            normalizedAppointments,
            appointment
          );
          if (equalAppointmentIndex === -1) {
            normalizedAppointments.push(appointment);
          } else {
            // appointment.dates = new Set([
            //   ...appointment.dates,
            //   ...normalizedAppointments[equalAppointmentIndex].dates,
            // ]);
            normalizedAppointments[equalAppointmentIndex] = appointment;
          }
        }

        const now = new Date();
        for (const appointment of normalizedAppointments) {
          let nextDate = null;
          let lastDate = null;
          const dateString = appointment.Date + "T" + appointment.Time;
          // for (const dateString of appointment.dates) {
          if (dateString !== "") {
            const date = new Date(dateString);
            if (date > now && (nextDate === null || nextDate > date)) {
              nextDate = date;
            } else if (date < now && (lastDate === null || lastDate < date)) {
              lastDate = date;
            }
          }
          // }
          if (nextDate) {
            appointment.nextDate = nextDate;
          }
          appointment.lastDate = lastDate;
          if (nextDate || lastDate) {
            appointment.status = getAppointmentStatus(appointment);
            appointments.push(appointment);
          }
          if (!appointment.IsUserAppointmentOnly) {
            doctors.push(appointment);
          }
        }
      }

      if (doctorsResponse.data.Result.User) {
        const userDoctors = [];
        for (const [
          userDoctorIndex,
          userDoctor,
        ] of doctorsResponse.data.Result.User.entries()) {
          userDoctor.Index = userDoctorIndex;
          userDoctor.From = "User";
          const equalAppointmentDoctorIndex = findDoctorIndex(
            doctors,
            userDoctor
          );
          if (equalAppointmentDoctorIndex === -1) {
            const equalDoctorIndex = findDoctorIndex(userDoctors, userDoctor);
            if (equalDoctorIndex === -1) {
              userDoctors.push(userDoctor);
            } else {
              userDoctors[equalDoctorIndex] = userDoctor;
            }
          }
        }
        doctors = [...doctors, ...userDoctors];
      }

      if (doctorsResponse.data.Result.Proposed) {
        for (const [
          proposedDoctorIndex,
          proposedDoctor,
        ] of doctorsResponse.data.Result.Proposed.entries()) {
          proposedDoctor.DoctorId = proposedDoctorIndex;
          const equalDoctorIndex = findDoctorIndex(doctors, proposedDoctor);
          if (equalDoctorIndex === -1) {
            const equalProposedDoctorIndex = findDoctorIndex(
              proposed,
              proposedDoctor
            );
            if (equalProposedDoctorIndex === -1) {
              proposed.push(proposedDoctor);
            } else {
              proposed[equalProposedDoctorIndex] = proposedDoctor;
            }
          }
        }
      }

      appointments.sort((a, b) => {
        // if (
        //   ["appointmentDecline", "appointmentCancel"].includes(a.status) &&
        //   !["appointmentDecline", "appointmentCancel"].includes(b.status) &&
        //   a.nextDate
        // ) {
        //   return 1;
        // } else if (
        //   !["appointmentDecline", "appointmentCancel"].includes(a.status) &&
        //   ["appointmentDecline", "appointmentCancel"].includes(b.status) &&
        //   b.nextDate
        // ) {
        //   return -1;
        // } else
        if (a.nextDate && b.nextDate) {
          return new Date(a.nextDate) - new Date(b.nextDate);
        } else if (a.nextDate && b.lastDate) {
          return -1;
        } else if (a.lastDate && b.nextDate) {
          return 1;
        } else {
          return new Date(b.lastDate) - new Date(a.lastDate);
        }
      });
      doctors.sort((a, b) => {
        let aName = a.Surname;
        let bName = b.Surname;
        if (a.Type === "clinic") {
          aName = a.Clinicname;
        }
        if (b.Type === "clinic") {
          bName = b.Clinicname;
        }
        return aName?.localeCompare(bName);
      });
      proposed.reverse();

      store.commit("setDoctors", {
        doctors: doctors,
        appointments: appointments,
        proposed: proposed,
      });
    }
  };

  return { doctorData, addDoctor, getDoctors, getAppointmentStatus };
}
